(() => {
  if (customElements.get('casekoo-offer-countdown')) return;
  // A single deadline is shared by product pages in this browsing tab.
  // This visual component never changes prices, discounts, carts or checkout.
  const deadlines = new Map();
  class CasekooOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.digits = this.querySelector('[data-timer-digits]');
      if (!this.digits) return;
      const minutes = Math.min(60, Math.max(1, Number(this.dataset.minutes) || 15));
      const key = this.dataset.storageKey + '-' + minutes;
      let deadline = deadlines.get(key);
      try {
        const saved = Number(sessionStorage.getItem(key));
        if (saved > 0 && Number.isFinite(saved)) deadline = saved;
        if (!deadline) {
          deadline = Date.now() + minutes * 60000;
          sessionStorage.setItem(key, String(deadline));
        }
      } catch (_) {
        // If storage is blocked, retain the deadline for this document only.
        deadline ||= Date.now() + minutes * 60000;
      }
      deadlines.set(key, deadline);
      this.deadline = deadline;
      this.onVisibility = () => this.update();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.update();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.update(), 1000);
    }
    update() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!seconds) {
        clearInterval(this.interval);
        if (this.dataset.expiry === 'ended') {
          this.querySelector('[data-timer-copy]').textContent = this.dataset.endedText;
          this.hidden = false;
        } else this.hidden = true;
        return;
      }
      this.digits.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      this.hidden = false;
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  }
  customElements.define('casekoo-offer-countdown', CasekooOfferCountdown);
})();
